/**
 * Density rule for DefaultSourceBadge: hide when the value at `source`
 * matches the next-lower scope's value, unless `showAll` is true.
 *
 * @param {Record<string, string>} sources
 * @param {Record<string, Record<string, unknown>>} layers
 * @param {string} key
 * @param {boolean} showAll
 * @returns {boolean}
 */
const SCOPE_ORDER = ["manifest", "global", "solution", "account"]

function nextLowerValue(layers, key, source) {
  const idx = SCOPE_ORDER.indexOf(source)
  if (idx <= 0) return undefined
  for (let i = idx - 1; i >= 0; i -= 1) {
    const layer = layers?.[SCOPE_ORDER[i]]
    if (layer && Object.prototype.hasOwnProperty.call(layer, key)) {
      return layer[key]
    }
  }
  return undefined
}

export function shouldShowSourceBadge(sources, layers, key, showAll = false) {
  if (!key) return false
  const source = sources?.[key]
  if (!source) return false
  if (source === "manifest") return !!showAll
  if (showAll) return true
  const current = layers?.[source]?.[key]
  const lower = nextLowerValue(layers, key, source)
  if (lower === undefined) return true
  try {
    return JSON.stringify(current) !== JSON.stringify(lower)
  } catch {
    return true
  }
}

/**
 * Highest-priority non-manifest source among keys (for composite cards).
 */
export function highestSourceAmong(sources, keys) {
  const rank = { account: 4, solution: 3, global: 2, manifest: 1 }
  let best = null
  let bestRank = 0
  ;(keys || []).forEach((k) => {
    const s = sources?.[k]
    if (!s) return
    const r = rank[s] || 0
    if (r > bestRank) {
      bestRank = r
      best = s
    }
  })
  return best
}

export default shouldShowSourceBadge
